
/**
 * `MmeFlyout` - This component encapsulates the whole mme functionality that can be present in the header.
 */

import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import OwcHeaderButton from '@owc-packages/Header/src/HeaderButton.vue';
import OwcLogo from '@owc-packages/Header/src/HeaderLogo.vue';
import { MmeFlyoutComponent } from './HeaderMercedesMeFlyout';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

export default (ComponentInitializeDispatcher as MmeFlyoutComponent).extend({
  name: 'owc-header-mercedes-me-flyout',
  components: {
    OwcHeaderButton,
    OwcLogo,
    SlotContainer,
    ValidationBoxWrapper,
  },
  props: {
    flyout: {
      type: Object,
      required: true,
    },
    userData: {
      type: Object,
      required: false,
    },
  },
  mounted() {
    //TODO FIXME: this logic will be removed once b2x makes the button appearance as default
    this.loginComponentSlots = this.$el.querySelectorAll('slot[name="seamless-iam-login-button"]');
    // FIXME: check if this can be done without the loop, attaching the listener directly on this.$el
    this.loginComponentSlots.forEach((slot: HTMLSlotElement) => {
      slot.addEventListener('slotchange', () => {
        let loginComponents = slot?.assignedElements() as HTMLElement[];
        loginComponents = loginComponents.filter(el => el.tagName === 'IAM-LOGIN-BUTTON');

        loginComponents.forEach(loginComponent => {
          loginComponent.setAttribute('integration-context', 'HEADER_V2');
        });
      });
    });
  },
  computed: {
    headline() {
      return this.flyout?.menuTitle;
    },
    subtext() {
      return this.flyout?.menuText;
    },
    registerAction() {
      return this.flyout?.register;
    },
    salutation() {
      return this.flyout?.salutation;
    },
    overviewEntries() {
      return this.flyout?.overviewEntries;
    },
    menuEntries() {
      return this.flyout?.menuEntries;
    },
    settingsEntries() {
      return this.flyout?.settingsEntries;
    },
    userName() {
      if (!this.userData) {
        return '';
      } else {
        return `${this.userData.firstName || ''} ${this.userData.lastName || ''}`;
      }
    },
  },
  methods: {
    closeFlyout() {
      this.$emit('closeFlyout');
    },
    handleRegisterClick() {
      this.handleCustomTracking(this.$el, 'register', 'link', 'click');
    },
  },
});
